export default __webpack_public_path__ + "static/media/notfound.9fb11fb0.png";